export default [
  { label: 'Portion', value: 'portion' },
  { label: 'Net carbs', value: 'netCarbs' },
  { label: 'Calories', value: 'calories' },
  { label: 'Fat', value: 'fat' },
  { label: 'Protein', value: 'protein' },
  { label: 'Fiber', value: 'fiber' },
];
